'use client'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useAsset } from '@marketplace-web/shared/assets'

const useHowItWorksClosingSubSectionContent = () => {
  const asset = useAsset('/assets/landing-pages/dac7')

  const isExtSubSectionEnabled = useFeatureSwitch('web_dac7_how_it_works_ext_sub_section')

  const generateImageAsset = (filename: string) => {
    const closingImageSrc = asset(`${filename}-Desktop.png`, {
      theme: { dark: `${filename}-Desktop-dark.png` },
    })
    const closingImageSrc2x = asset(`${filename}-Desktop@2x.png`, {
      theme: { dark: `${filename}-Desktop-dark@2x.png` },
    })
    const closingImageSrc3x = asset(`${filename}-Desktop@3x.png`, {
      theme: { dark: `${filename}-Desktop-dark@3x.png` },
    })
    const closingImageSrcSet = `${closingImageSrc} 1x, ${closingImageSrc2x} 2x, ${closingImageSrc3x} 3x`

    const closingImageSrcMobile = asset(`${filename}-mobile.png`, {
      theme: { dark: `${filename}-mobile-dark.png` },
    })
    const closingImageSrcMobile2x = asset(`${filename}-mobile@2x.png`, {
      theme: { dark: `${filename}-mobile-dark@2x.png` },
    })
    const closingImageSrcMobile3x = asset(`${filename}-mobile@3x.png`, {
      theme: { dark: `${filename}-mobile-dark@3x.png` },
    })
    const closingImageSrcSetMobile = `${closingImageSrcMobile} 1x, ${closingImageSrcMobile2x} 2x, ${closingImageSrcMobile3x} 3x`

    return {
      webImageSrc: closingImageSrc,
      webImageSrcSet: closingImageSrcSet,
      mobileImageSrc: closingImageSrcMobile,
      mobileImageSrcSet: closingImageSrcSetMobile,
    }
  }

  const basicContent = {
    ...generateImageAsset('Illustration-5'),
    titleTranslationKey: 'closing.title',
    descriptionTranslationKey: 'closing.description',
    linkTranslationKey: 'column_1.link_1',
    linkTestId: 'howitworks-section--hyperlink-helpcenter',
  }

  const extContent = {
    ...generateImageAsset('howitworks-closing-ext'),
    titleTranslationKey: 'closing_ext.title',
    descriptionTranslationKey: 'closing_ext.description',
    linkTranslationKey: undefined,
    linkTestId: undefined,
  }

  if (isExtSubSectionEnabled) {
    return {
      nonUkVersionContent: [extContent, basicContent],
      ukVersionContent: [extContent],
    }
  }

  return {
    nonUkVersionContent: [basicContent],
    ukVersionContent: [],
  }
}

export default useHowItWorksClosingSubSectionContent
